import {LectioJSUtils} from './../LectioJSUtils';

export class LCDocumentEditorService {
	private static GetServiceUrl(operation: string): string {
		return LectioJSUtils.GetBaseSchoolURL() + '/lcutil/editorapi.api/' + operation;
	}
	static GetUrlTitle(url: string): JQueryXHR {
		return $.get(this.GetServiceUrl('GetUrlTitle'), { url: url });
	}
	static GetOembedMarkup(url: string): JQueryXHR {
		return $.get(this.GetServiceUrl('GetOembedMarkup'), { url: url });
	}
}
